import * as React from "react";
import { joinClasses } from "../../../utils/Filters";
import { ensure } from "../../../utils/Optional";
import licensePlateLogo from "../../../assets/images/libs/core/background-licenseplate.svg";
import * as I18n from "../../../utils/translations/I18n";
/**
 *
 * @param props
 */
export var LicensePlateInput = function (props) {
    var clazzName = joinClasses(props.className, "scl-a-input__field", "scl-a-license__plate");
    var onChange = !!props.onChange
        ? function (evt) {
            evt.preventDefault();
            ensure(props.onChange)(evt.target.value || undefined);
        }
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { src: licensePlateLogo, alt: "license-plate", className: "scl-a-license__background" }),
        React.createElement("input", { type: "text", className: clazzName, value: props.value, onChange: onChange, disabled: !!props.disabled, required: props.required, placeholder: I18n.getText("mary.05-atoms.licenseplateinput.placeholder", "CL-001-E") })));
};
